import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import TimelineIcon from '@mui/icons-material/Timeline';
import PieChartIcon from '@mui/icons-material/PieChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BusinessIcon from '@mui/icons-material/Business';
import SellIcon from '@mui/icons-material/Sell';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SectionLayout from '../../components/layout/SectionLayout';
import { SideSection } from '../../components/layout/SideNav';

const SECTIONS: SideSection[] = [
  {
    label: 'Visão geral',
    links: [
      { label: 'Painel', path: '/stocks', icon: <DashboardIcon /> },
      { label: 'Análise da carteira', path: '/stocks/portfolio', icon: <AnalyticsIcon /> },
      { label: 'Desempenho', path: '/stocks/performance', icon: <TimelineIcon /> },
    ],
  },
  {
    label: 'Gestão de investimentos',
    links: [
      { label: 'Ações', path: '/stocks/list', icon: <ShowChartIcon /> },
      { label: 'ETFs', path: '/stocks/etfs', icon: <BusinessIcon /> },
      { label: 'Dividendos', path: '/stocks/dividends', icon: <AccountBalanceIcon /> },
      { label: 'Vendas', path: '/stocks/sales', icon: <SellIcon /> },
      { label: 'Importar / Exportar', path: '/stocks/import-export', icon: <UploadFileIcon /> },
    ],
  },
  {
    label: 'Análise e relatórios',
    links: [
      { label: 'Alocação', path: '/stocks/allocation', icon: <PieChartIcon /> },
      { label: 'Tendências de mercado', path: '/stocks/trends', icon: <TrendingUpIcon /> },
    ],
  },
];

const StocksLayout: React.FC = () => (
  <SectionLayout title="Carteira de investimentos" icon={<ShowChartIcon fontSize="small" />} sections={SECTIONS} />
);

export default StocksLayout;
